module.exports = __webpack_public_path__ + "img/piano.be5030ca.webp";